// extracted by mini-css-extract-plugin
export default {"selectDay":"SelectDayCarousel_selectDay__7yJ76 mixins_horizontalScroll__vOx9O","dayItem":"SelectDayCarousel_dayItem__soh-F"};